import { getToken } from './auth';

const API_DOMAIN = process.env.REACT_APP_API_URL;

export type ApiClient = (endpoint: string, method: string, data?: any) => Promise<Response>;

export const CallApi = (service: string): ApiClient => async (endpoint: string, method: string, data?: any) => {

  const token = await getToken();

  if (!token) {
    // throw new Error('Missing token!');
    window.location.reload();
    return {} as Response;
  }

  const headers = new Headers()
  headers.append('Authorization', token);
  headers.append('Content-Type', 'application/json');

  const params: RequestInit = {
    method,
    headers,
  }

  if (data) {
    if (method !== 'GET') {
      params.body = JSON.stringify(data);
    } else {
      endpoint = `${endpoint}?${new URLSearchParams(data).toString()}`
    }
  }

  return fetch(`${ API_DOMAIN }${service}${ endpoint }`, params)
}

export const handleResponse = async (response: Response) => {

  const data = await response.text();

  if (!response.ok) {
    throw new Error(data);
  }

  return data;
}

export const handleJSONResponse = async (response: Response) => {

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.code);
  }

  if (!data) {
    return;
  }

  if ('created_at' in data) {
    data.created_at = new Date(data.created_at)
  }

  if ('updated_at' in data) {
    data.updated_at = new Date(data.updated_at)
  }

  return data;
}
